import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2c0e1062&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=2c0e1062&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0e1062",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c0e1062')) {
      api.createRecord('2c0e1062', component.options)
    } else {
      api.reload('2c0e1062', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2c0e1062&scoped=true", function () {
      api.rerender('2c0e1062', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/subscription-events/index.vue"
export default component.exports